/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	/* jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	}); */


	$(".menu-icon-svg").on("click", function () {
		//$(this).toggleClass("z-control");
		$('body').toggleClass("menu-scroll-fix");
		$('.top-bar').toggleClass("z-control");
		$('.mobile-nav-wrap').toggleClass("active");
		$('header.header').toggleClass("active");
		console.log('click');
	  });

	  $(".close-icon").on("click", function () {
		$(this).toggleClass("active");
		$('body').toggleClass("menu-scroll-fix");
		$('.top-bar').toggleClass("z-control");
		$('.mobile-nav-wrap').toggleClass("active");
		$('header.header').toggleClass("active");
	  });
	


	//Smooth scroll
	// filter handling for a /dir/ OR /indexordefault.page
function filterPath(string) {
	return string
	  .replace(/^\//, '')
	  .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
	  .replace(/\/$/, '');
  }
  
  var locationPath = filterPath(location.pathname);
  $('a[href*="#"]').each(function () {
	var thisPath = filterPath(this.pathname) || locationPath;
	var hash = this.hash;
	if ($("#" + hash.replace(/#/, '')).length) {
	  if (locationPath == thisPath && (location.hostname == this.hostname || !this.hostname) && this.hash.replace(/#/, '')) {
		var $target = $(hash), target = this.hash;
		if (target) {
		  $(this).click(function (event) {
			event.preventDefault();
			$('html, body').animate({scrollTop: $target.offset().top}, 1000, function () {
			  location.hash = target; 
			  $target.focus();
			  if ($target.is(":focus")){ //checking if the target was focused
				return false;
			  }else{
				$target.attr('tabindex','-1'); //Adding tabindex for elements not focusable
				$target.focus(); //Setting focus
			  };
			});       
		  });
		}
	  }
	}
  });


  


}); 